import { Typography, Divider } from 'antd'
import './style.less'

const { Title } = Typography

const SectionTitle = (props) => {
  return (
    <div className="SectionTitle mt-2">
      <span className="SectionTitle-icon">{props.icon}</span>
      <Title level={5} className="SectionTitle-title ">{props.title}</Title>
      <div className="SectionTitle-divider ">
        <Divider />
      </div>
    </div>
  )
}

export default SectionTitle